module.exports = {"340803001":"德宽路街道","340803002":"玉琳路街道","340803003":"龙山路街道","340803004":"菱湖街道","340803005":"集贤路街道","340803006":"石化路街道","340803007":"花亭路街道","340803100":"海口镇","340803200":"十里铺乡","340803201":"山口乡","340803400":"大观开发区","340803401":"安徽安庆海口经济开发区","340803500":"皖河农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340803.json
// module id = 1004
// module chunks = 0